import React, { useState, useEffect } from "react";

const Clients = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hoveredBtn, setHoveredBtn] = useState(null);

  const testimonials = [
    {
      id: 1,
      name: "Rahul Mehta",
      role: "Mumbai",
      image: "https://i.pravatar.cc/150?u=rahul",
      text: "I had already lost a good amount of money before connecting with Gaurav. I was frustrated and almost ready to quit crypto. He first helped me understand where I went wrong, then guided me step by step to rebuild my portfolio. Within months, I started seeing steady growth. His approach is honest, practical, and very easy to follow.",
    },
    {
      id: 2,
      name: "Sneha Kapoor",
      role: "Delhi",
      image: "https://i.pravatar.cc/150?u=sneha",
      text: "As a complete beginner, crypto felt very confusing and risky to me. Gaurav explained everything in a simple way—from basics to investment strategies. He never rushed me and always answered my questions patiently. Today, I invest with clarity and confidence, and I finally feel in control of my decisions.",
    },
    {
      id: 3,
      name: "Amit Sharma",
      role: "Bangalore",
      image: "https://i.pravatar.cc/150?u=amit",
      text: "I've worked with a few advisors before, but Gaurav stands out. His knowledge about crypto security is exceptional. He helped me fix major gaps in how I was handling my assets and literally saved me from a potential scam. That one decision alone protected a big part of my investment.",
    },
    {
      id: 4,
      name: "Priya Verma",
      role: "Kolkata",
      image: "https://i.pravatar.cc/150?u=priya",
      text: "What I like most about Gaurav is his professionalism and clarity. He doesn't overpromise—he explains risks and opportunities honestly. With his guidance, my investments have become more stable, and I've seen consistent improvement in my portfolio performance.",
    },
    {
      id: 5,
      name: "Rohit Jain",
      role: "Dubai",
      image: "https://i.pravatar.cc/150?u=rohit",
      text: "Being in an international market, I needed someone who understands global crypto trends—and Gaurav delivered. His strategies are practical and based on real market conditions, not hype. His insights have helped me make smarter and more timely investment decisions.",
    },
    {
      id: 6,
      name: "Ankit Singh",
      role: "Pune",
      image: "https://i.pravatar.cc/150?u=ankit",
      text: "I started with zero knowledge about crypto and was honestly scared to invest. Gaurav guided me from the basics and helped me build a proper investment plan. Over time, I gained confidence and started seeing real results. This journey wouldn't have been possible without his support.",
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1,
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1,
    );
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section style={styles.section}>
      {/* Vibrant Warm Mesh Glows */}
      <div style={styles.meshGlowLeft}></div>
      <div style={styles.meshGlowRight}></div>

      <div style={styles.container}>
        <div style={styles.header}>
          <span style={styles.subtitle}>Testimonials</span>
          <h2 style={styles.heading}>What Our Clients Say</h2>
          <div style={styles.divider}></div>
        </div>

        <div style={styles.sliderContent}>
          {/* Left Arrow */}
          <button
            onClick={prevSlide}
            onMouseEnter={() => setHoveredBtn("prev")}
            onMouseLeave={() => setHoveredBtn(null)}
            style={{
              ...styles.arrowBtn,
              left: "-80px",
              ...(hoveredBtn === "prev" ? styles.arrowHover : {}),
            }}
          >
            ‹
          </button>

          <div style={styles.testimonialCard}>
            <div style={styles.quoteIcon}>“</div>
            <p style={styles.testimonialText}>
              {testimonials[currentIndex].text}
            </p>

            <div style={styles.profileArea}>
              <img
                src={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].name}
                style={styles.profileImage}
              />
              <div style={styles.profileInfo}>
                <h4 style={styles.profileName}>
                  {testimonials[currentIndex].name}
                </h4>
                <p style={styles.profileRole}>
                  {testimonials[currentIndex].role}
                </p>
              </div>
            </div>
          </div>

          {/* Right Arrow */}
          <button
            onClick={nextSlide}
            onMouseEnter={() => setHoveredBtn("next")}
            onMouseLeave={() => setHoveredBtn(null)}
            style={{
              ...styles.arrowBtn,
              right: "-80px",
              ...(hoveredBtn === "next" ? styles.arrowHover : {}),
            }}
          >
            ›
          </button>
        </div>

        {/* Navigation Dots */}
        <div style={styles.navDots}>
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              style={{
                ...styles.dot,
                backgroundColor:
                  currentIndex === index
                    ? "#f59e0b"
                    : "rgba(245, 158, 11, 0.2)",
                width: currentIndex === index ? "30px" : "10px",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "120px 20px",
    // ✅ Sunset-inspired base
    background: "linear-gradient(to bottom, #5e0732, #3c004e)",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
  },
  // ✅ Vibrant Orange/Amber Mesh
  meshGlowLeft: {
    position: "absolute",
    top: "-10%",
    left: "-5%",
    width: "50%",
    height: "70%",
    background:
      "radial-gradient(circle, rgba(245, 158, 11, 0.15) 0%, rgba(255, 255, 255, 0) 70%)",
    pointerEvents: "none",
    filter: "blur(60px)",
  },
  // ✅ Vibrant Crimson/Rose Mesh
  meshGlowRight: {
    position: "absolute",
    bottom: "-10%",
    right: "-5%",
    width: "50%",
    height: "70%",
    background:
      "radial-gradient(circle, rgba(251, 146, 60, 0.2) 0%, rgba(255, 255, 255, 0) 70%)",
    pointerEvents: "none",
    filter: "blur(60px)",
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
  },
  header: { marginBottom: "50px" },
  subtitle: {
    fontSize: "14px",
    fontWeight: "800",
    color: "#fbbf24", // Warm Amber
    textTransform: "uppercase",
    letterSpacing: "4px",
    display: "block",
    marginBottom: "12px",
  },
  heading: {
    fontSize: "clamp(28px, 5vw, 40px)",
    fontWeight: "900",
    color: "#ffffff",
    margin: 0,
    letterSpacing: "-1px",
  },
  divider: {
    width: "80px",
    height: "5px",
    background: "linear-gradient(to right, #f59e0b, #ea580c)",
    margin: "24px auto 0",
    borderRadius: "20px",
  },
  sliderContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginTop: "40px",
  },
  testimonialCard: {
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(20px)",
    padding: "60px 40px",
    borderRadius: "40px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
    width: "100%",
    position: "relative",
  },
  arrowBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    color: "white",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    fontSize: "30px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    zIndex: 10,
    // Note: arrows might go off-screen on mobile, usually hidden or moved inside
  },
  arrowHover: {
    background: "#f59e0b",
    borderColor: "#f59e0b",
    boxShadow: "0 0 20px rgba(245, 158, 11, 0.4)",
  },
  quoteIcon: {
    fontSize: "80px",
    color: "#fbbf24",
    opacity: "0.15",
    position: "absolute",
    top: "10px",
    left: "30px",
    fontFamily: "serif",
  },
  testimonialText: {
    fontSize: "20px",
    lineHeight: "1.8",
    color: "#ffedd5", // Light peach text
    fontStyle: "italic",
    marginBottom: "40px",
    fontWeight: "300",
  },
  profileArea: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "15px",
  },
  profileImage: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: "2px solid #fbbf24",
  },
  profileInfo: { textAlign: "left" },
  profileName: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#ffffff",
    margin: 0,
  },
  profileRole: {
    fontSize: "14px",
    color: "#fbbf24",
    margin: 0,
    fontWeight: "700",
    textTransform: "uppercase",
  },
  navDots: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "40px",
  },
  dot: {
    height: "10px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};

export default Clients;
